var o,n;!function(o){o.checkbox="CHECKBOX",o.radio="RADIO",o.dropdown="DROP_DOWN"}(o||(o={})),function(o){o.HORIZONTAL="horizontal",o.VERTICAL="vertical"}(n||(n={}));export{n as FormOptionsLayout,o as FormOptionsTypes};
